import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.categoryManagement,
    component: () => import('../../pages/tagsManagement/categoryManagement/list'),
    meta: { title: '标签分组' }
  },
  {
    path: routeNames.tagsManagementList,
    component: () => import('../../pages/tagsManagement/tagsManagement/list'),
    meta: { title: '标签列表' }
  },
  {
    path: routeNames.tagCategory,
    component: () => import('../../pages/tagsManagement/tagCategory/list'),
    meta: { title: '标签分类' }
  }
] as TRoutes[]
